/**
 * Where vehicle-event toasts go right now.
 *
 * Normally they stack in the Toaster's default corner (bottom-right). While one vehicle is followed,
 * its docked details panel sits in that same corner, and every new toast pushed it around. The panel
 * holds a placement for as long as it is mounted, and `VehicleEventListener` shows new toasts at the
 * bottom centre instead: still visible, and clear of the panel on a desktop-width screen.
 *
 * Ref-counted and module-level, like `dismissed-store.ts`: no React state, nothing persisted.
 */

let holders = 0;
const listeners = new Set<() => void>();

function notify() {
  for (const listener of listeners) listener();
}

/** Moves vehicle-event toasts to the bottom centre until the returned release is called. Idempotent. */
export function centerVehicleToasts(): () => void {
  holders += 1;
  if (holders === 1) notify();
  let released = false;
  return () => {
    if (released) return;
    released = true;
    holders -= 1;
    if (holders === 0) notify();
  };
}

export function areVehicleToastsCentered(): boolean {
  return holders > 0;
}

/** Called whenever the placement switches. Returns an unsubscribe function. */
export function subscribeVehicleToastPlacement(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
